import LegalPageLayout from './LegalPageLayout'
import { LEGAL_DOCS } from '../../constants/legalContent'

export default function PrivacyPolicyPage() {
  const doc = LEGAL_DOCS.privacyPolicy
  return (
    <LegalPageLayout
      pageTitle={doc.pageTitle}
      effectiveDate={doc.effectiveDate}
      sections={doc.sections}
    />
  )
}

